/*
  Translations for the licence gate of self-hosted installs.
  Merged into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const LICENCE_SETUP_INTRO =
  'Enter the licence key from your account (page Self-hosted). It activates this server, which then renews its licence once a day on its own.';
const LICENCE_STOPPED =
  'The licence of this installation has run out or is no longer valid, so the tracker is stopped. Check the Enterprise subscription and the key, then activate again.';
const LICENCE_WARNING =
  'The licence could not be renewed. The tracker keeps working until {date} and then stops unless a renewal succeeds.';
const LICENCE_TEST_BANNER =
  'Test server: limited to {n} clicks a day.';
const LICENCE_ASK_ADMIN =
  'This installation is not licensed. Ask the administrator to activate it.';

const ru = {
  [LICENCE_SETUP_INTRO]:
    'Введите лицензионный ключ из своего аккаунта (страница «Свой сервер»). Он активирует этот сервер, дальше лицензия продлевается сама раз в сутки.',
  [LICENCE_STOPPED]:
    'Лицензия этой установки закончилась или больше не действительна, поэтому трекер остановлен. Проверьте подписку Enterprise и ключ, затем активируйте снова.',
  [LICENCE_WARNING]:
    'Лицензию не удалось продлить. Трекер работает до {date}, после чего остановится, если продление не пройдёт.',
  [LICENCE_TEST_BANNER]:
    'Тестовый сервер: не более {n} кликов в сутки.',
  [LICENCE_ASK_ADMIN]:
    'Эта установка не активирована. Попросите администратора её активировать.',
  'Licence activated': 'Лицензия активирована',
  'Licence expired': 'Лицензия недействительна',
  'Activate this installation': 'Активация установки',
  'Licensed to {who} · licence {id}': 'Лицензия: {who} · {id}',
};

const es = {
  [LICENCE_SETUP_INTRO]:
    'Introduce la clave de licencia de tu cuenta (página Servidor propio). Activa este servidor, que después renueva su licencia solo una vez al día.',
  [LICENCE_STOPPED]:
    'La licencia de esta instalación ha vencido o ya no es válida, por lo que el tracker está detenido. Revisa la suscripción Enterprise y la clave, y vuelve a activarla.',
  [LICENCE_WARNING]:
    'No se pudo renovar la licencia. El tracker funciona hasta el {date} y luego se detiene si la renovación no se completa.',
  [LICENCE_TEST_BANNER]:
    'Servidor de prueba: limitado a {n} clics al día.',
  [LICENCE_ASK_ADMIN]:
    'Esta instalación no tiene licencia. Pide al administrador que la active.',
  'Licence activated': 'Licencia activada',
  'Licence expired': 'Licencia no válida',
  'Activate this installation': 'Activar esta instalación',
  'Licensed to {who} · licence {id}': 'Licencia: {who} · {id}',
};

const pt = {
  [LICENCE_SETUP_INTRO]:
    'Insira a chave de licença da sua conta (página Servidor próprio). Ela ativa este servidor, que depois renova a licença sozinho uma vez por dia.',
  [LICENCE_STOPPED]:
    'A licença desta instalação expirou ou não é mais válida, por isso o tracker está parado. Verifique a assinatura Enterprise e a chave e ative novamente.',
  [LICENCE_WARNING]:
    'Não foi possível renovar a licença. O tracker funciona até {date} e depois para, a menos que a renovação dê certo.',
  [LICENCE_TEST_BANNER]:
    'Servidor de teste: limitado a {n} cliques por dia.',
  [LICENCE_ASK_ADMIN]:
    'Esta instalação não tem licença. Peça ao administrador para ativá-la.',
  'Licence activated': 'Licença ativada',
  'Licence expired': 'Licença inválida',
  'Activate this installation': 'Ativar esta instalação',
  'Licensed to {who} · licence {id}': 'Licença: {who} · {id}',
};

export {
  LICENCE_SETUP_INTRO,
  LICENCE_STOPPED,
  LICENCE_WARNING,
  LICENCE_TEST_BANNER,
  LICENCE_ASK_ADMIN,
};
const INSTANCE_LICENCE = { ru, es, pt };
export default INSTANCE_LICENCE;
